<template>
  <section class="section white-panel">
    <h2 class="fs16 mt4 mb12">{{ transitionFrom === 'fromEstimate' ? 'この機会にお車の乗換をご検討のお客様へ' : 'リースのご紹介' }}</h2>
      <div v-if="car.id === '' || firstRegistrationOn > sevenYearsAgo" >
        <p class="mb16 text-center">
            <a v-on:click="jsOpenBrowser('http://www.cosmo-mycar.com/CarLifeSquare.html?c=002&popinfo=ID_' + popInfoNo + '&utm_source=app&utm_medium=Carlife Square_app&utm_campaign=banner_kahenNo1', 'MOVED_LEASE')"><img src="lib/images/mycar-round.jpg" alt=""></a>
        </p>
      </div>
      <div v-if="car.id !== '' && firstRegistrationOn < sevenYearsAgo && (car.model_code === 1 || car.model_code === 2)">
        <p class="mb16 text-center">
            <a v-on:click="jsOpenBrowser('http://www.cosmo-mycar.com/CarLifeSquare.html?c=005&popinfo=ID_' + popInfoNo + '&utm_source=app&utm_medium=Carlife Square_app&utm_campaign=banner_kahenNo2', 'MOVED_LEASE')"><img src="lib/images/hutsujidousya-round.jpg" alt=""></a>
        </p>
      </div>
      <div v-if="car.id !== '' && firstRegistrationOn < sevenYearsAgo && car.model_code === 3">
        <p class="mb16 text-center">
            <a v-on:click="jsOpenBrowser('http://www.cosmo-mycar.com/CarLifeSquare.html?c=006&popinfo=ID_' + popInfoNo + '&utm_source=app&utm_medium=Carlife Square_app&utm_campaign=banner_kahenNo2', 'MOVED_LEASE')"><img src="lib/images/keijidousya-round.jpg" alt=""></a>
        </p>
      </div>
    <ul class="flex stretch ul-col2">
      <li><button class="button button-gray w100p pd12 ic-left ic-car-lease1 radius200 fs14" v-on:click="jsOpenBrowser('http://www.cosmo-mycar.com/CarLifeSquare.html?c=003&popinfo=ID_' + popInfoNo + '&utm_source=app&utm_medium=Carlife Square_app&utm_campaign=banner_first_guide', 'MOVED_LEASE_FIRST')">初めての方へ</button></li>
      <li><button class="button button-gray w100p pd12 ic-left ic-car-lease2 radius200 fs14" v-on:click="jsOpenBrowser('http://www.cosmo-mycar.com/CarLifeSquare.html?c=004&popinfo=ID_' + popInfoNo + '&utm_source=app&utm_medium=Carlife Square_app&utm_campaign=banner_car_estimate', 'MOVED_LEASE_SEARCH')">車の選び方</button></li>
    </ul>
    <p class=""><button class="button fs16 w100p radius200" v-on:click="jsOpenBrowser('http://www.cosmo-mycar.com/CarLifeSquare.html?c=001&popinfo=ID_' + popInfoNo + '&utm_source=app&utm_medium=Carlife Square_app&utm_campaign=banner_car_estimate', 'MOVED_LEASE_MITSUMORI')">今すぐ<br>お試し見積りを始める！</button></p>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      sevenYearsAgo: ''
    }
  },
  props: [
    'car',
    'popInfoNo',
    'transitionFrom'
  ],
  methods: {
    dateParse (date) {
      const year = Number(date.substr(0, 4))
      const month = Number(date.substr(5, 2)) - 1
      return new Date(year, month)
    },
    jsOpenBrowser: function (url, type) {
      // リースバナー
      if (type === 'MOVED_LEASE') {
        this.nativeEVENTSet('CarCareButton', 'MOVED_LEASE', 'TAP')
      }
      // リース 初めての方
      if (type === 'MOVED_LEASE_FIRST') {
        this.nativeEVENTSet('CarCareButton', 'MOVED_LEASE_FIRST', 'TAP')
      }
      // リース 車を探す
      if (type === 'MOVED_LEASE_SEARCH') {
        this.nativeEVENTSet('CarCareButton', 'MOVED_LEASE_SEARCH', 'TAP')
      }
      // リース 見積りタップ
      if (type === 'MOVED_LEASE_MITSUMORI') {
        this.nativeEVENTSet('CarCareButton', 'MOVED_LEASE_MITSUMORI', 'TAP')
      }
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    }
  },
  computed: {
    firstRegistrationOn () {
      return this.dateParse(this.car.first_registration_on)
    }
  },
  async mounted () {
    // 現在時刻より7年前の変数を作成
    this.sevenYearsAgo = moment().add(-7, 'years').toDate()
  }
}
</script>
